import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { createContext, useContext } from 'react';
import { bool, node, oneOf, shape, string } from 'prop-types';
const Context = /*#__PURE__*/createContext(false);

const ListContext = _ref => {
  let {
    children,
    value: {
      disableGutters
    }
  } = _ref,
      values = _objectWithoutPropertiesLoose(_ref.value, ["disableGutters"]);

  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: Object.assign({
      basis: disableGutters ? 32 : 40,
      gutters: disableGutters ? 0 : 3
    }, values)
  }, children);
};

export const useListContext = () => useContext(Context);
process.env.NODE_ENV !== "production" ? ListContext.propTypes = {
  children: node,
  value: shape({
    disableGutters: bool,
    scale: oneOf(['large', 'medium', 'small']),
    selectable: bool,
    type: string,
    variant: string,
    isCollapsed: bool
  })
} : void 0;
export default ListContext;